
function ScheduleIcon() {
	return (
		<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.625 7.64453H20.375" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path
				d="M18.5 3.89453H3.5C3.00272 3.89453 2.52581 4.09208 2.17417 4.44371C1.82254 4.79534 1.625 5.27225 1.625 5.76953V17.0195C1.625 17.5168 1.82254 17.9937 2.17417 18.3454C2.52581 18.697 3.00272 18.8945 3.5 18.8945H18.5C18.9973 18.8945 19.4742 18.697 19.8258 18.3454C20.1775 17.9937 20.375 17.5168 20.375 17.0195V5.76953C20.375 5.27225 20.1775 4.79534 19.8258 4.44371C19.4742 4.09208 18.9973 3.89453 18.5 3.89453Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M6.625 1.39453V3.89453" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M15.375 1.39453V3.89453" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
}

export default ScheduleIcon;
